import * as React from "react"
const SvgShareButton = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={50}
    height={50}
    fill="none"
    {...props}
  >
    <circle cx={25} cy={25} r={25} fill="#fff" />
    <path
      fill="#9C997C"
      d="M12.835 25.004c0 .453-.12.877-.321 1.24a2.52 2.52 0 0 1-2.19 1.28 2.517 2.517 0 0 1-2.511-2.52 2.517 2.517 0 0 1 2.51-2.52c.935 0 1.759.513 2.18 1.28.212.363.332.786.332 1.24M33.426 9.375a2.516 2.516 0 0 0-2.511 2.52 2.516 2.516 0 0 0 2.511 2.52 2.515 2.515 0 0 0 2.511-2.52 2.515 2.515 0 0 0-2.51-2.52m0 26.21a2.516 2.516 0 0 0-2.511 2.52 2.516 2.516 0 0 0 2.511 2.52 2.515 2.515 0 0 0 2.511-2.52 2.515 2.515 0 0 0-2.51-2.52m-1.768 1.518-19.57-11.1zm-19.57-13.106 19.57-11.1z"
    />
    <path
      stroke="#9C997C"
      strokeMiterlimit={10}
      strokeWidth={3}
      d="m12.088 23.997 19.57-11.1M12.835 25.002c0 .454-.12.878-.321 1.24a2.52 2.52 0 0 1-2.19 1.28 2.517 2.517 0 0 1-2.511-2.52 2.517 2.517 0 0 1 2.51-2.52c.935 0 1.759.514 2.18 1.28.212.363.332.787.332 1.24ZM33.426 9.375a2.516 2.516 0 0 0-2.511 2.52 2.516 2.516 0 0 0 2.511 2.52 2.515 2.515 0 0 0 2.511-2.52 2.515 2.515 0 0 0-2.51-2.52Zm0 26.21a2.516 2.516 0 0 0-2.511 2.52 2.516 2.516 0 0 0 2.511 2.52 2.515 2.515 0 0 0 2.511-2.52 2.515 2.515 0 0 0-2.51-2.52Zm-1.768 1.518-19.57-11.1z"
    />
  </svg>
)
export default SvgShareButton
